export enum WeatherType {
	EXTRASUNNY = 'extrasunny',
	CLEAR = 'clear',
	CLOUDS = 'clouds',
	SMOG = 'smog',
	FOG = 'foggy',
	OVERCAST = 'overcast',
	RAIN = 'rain',
	THUNDER = 'thunder',
	CLEARING = 'clearing',
	NEUTRAL = 'neutral',
	SNOW = 'snow',
	BLIZZARD = 'blizzard',
	SNOWLIGHT = 'snowlight',
	XMAS = 'xmas',
	HALLOWEEN = 'halloween',
}

export const weatherIndexByType: Record<WeatherType, number> = {
	[WeatherType.EXTRASUNNY]: 0,
	[WeatherType.CLEAR]: 1,
	[WeatherType.CLOUDS]: 2,
	[WeatherType.SMOG]: 3,
	[WeatherType.FOG]: 4,
	[WeatherType.OVERCAST]: 5,
	[WeatherType.RAIN]: 6,
	[WeatherType.THUNDER]: 7,
	[WeatherType.CLEARING]: 8,
	[WeatherType.NEUTRAL]: 9,
	[WeatherType.SNOW]: 10,
	[WeatherType.BLIZZARD]: 11,
	[WeatherType.SNOWLIGHT]: 12,
	[WeatherType.XMAS]: 13,
	[WeatherType.HALLOWEEN]: 14,
};

export enum SeasonType {
	None = 'None',
	Winter = 'Winter',
}

export const weatherTypesBySeason: Record<SeasonType, WeatherType[]> = {
	[SeasonType.None]: [
		WeatherType.EXTRASUNNY,
		WeatherType.CLEAR,
		WeatherType.CLOUDS,
		WeatherType.SMOG,
		WeatherType.FOG,
		WeatherType.OVERCAST,
		WeatherType.RAIN,
		WeatherType.THUNDER,
		WeatherType.CLEARING,
	],
	[SeasonType.Winter]: [
		WeatherType.EXTRASUNNY,
		WeatherType.CLEAR,
		WeatherType.CLOUDS,
		WeatherType.OVERCAST,
		WeatherType.SNOW,
		WeatherType.SNOWLIGHT,
		WeatherType.XMAS,
	],
};

export interface IHudWeather {
	weather: WeatherType;
	degrees: number;
}

export interface SeasonRange {
	start: number | null;
	end: number | null;
}
